import { render, staticRenderFns } from "./declaraciones_noconfirmadas_colaborador.vue?vue&type=template&id=5861c9d6"
import script from "./declaraciones_noconfirmadas_colaborador.js?vue&type=script&lang=js&external"
export * from "./declaraciones_noconfirmadas_colaborador.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports